
const leftPad = (origin, targetLength, padding) => {
  if (`${origin}`.length < targetLength) {
    return leftPad(padding + origin, targetLength, padding)
  }
  return origin
}

const formatSingleNumber = target => leftPad(target, 2, '0')

const formatTime = (timeStamp) => {
  const TimeObj = new Date(timeStamp)
  const year = TimeObj.getYear() + 1900
  const month = TimeObj.getMonth() + 1
  const date = TimeObj.getDate()
  const hour = TimeObj.getHours()
  const minute = TimeObj.getMinutes()
  return `${year}.${formatSingleNumber(month)}.${formatSingleNumber(date)} ${formatSingleNumber(hour)}:${formatSingleNumber(minute)}`
}
// 获取组合卡片系列课程的价格
const getSerialPrice = (minPrice, maxPrice) => {
  if (minPrice === maxPrice) {
    return minPrice;
  }
  return `${minPrice} - ${maxPrice}`;
}

export {
  leftPad,
  formatSingleNumber,
  formatTime,
  getSerialPrice,
}



// WEBPACK FOOTER //
// ./src/components/common/utils.js